import { Button } from "@/components/ui/button";
import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 text-9xl font-bold">404</div>
      <div className="mb-6 text-3xl font-semibold">Page Not Found</div>
      <p className="mb-8 max-w-md text-muted-foreground">The page you are looking for doesn't exist or has been moved.</p>
      <Button asChild>
        <Link to="/">Go back home</Link>
      </Button>
    </div>
  );
}
